import { KubesoloHostResult, KubesoloHostState } from '@api/types.gen';

export type HostGroup =
  | 'attention'
  | 'running'
  | 'queued'
  | 'passed'
  | 'alreadyInstalled';

/**
 * Needs attention leads, since those machines block the install and only the user can unblock them.
 * Running is next, so the user sees the test is alive.
 */
export const hostGroups: Array<HostGroup> = [
  'attention',
  'running',
  'queued',
  'passed',
  'alreadyInstalled',
];

export const groupLabels: Record<HostGroup, string> = {
  attention: 'Needs attention',
  running: 'Running',
  queued: 'Queued',
  passed: 'Passed',
  alreadyInstalled: 'Already installed',
};

const groupOfState: Record<KubesoloHostState, HostGroup> = {
  failed: 'attention',
  running: 'running',
  queued: 'queued',
  passed: 'passed',
  alreadyInstalled: 'alreadyInstalled',
};

/**
 * Sorts machines into groups. A changed host key tops Needs attention, since it can mean a
 * spoofed or reinstalled machine; queued machines are in queue order.
 */
export function groupHosts(
  hosts: Array<KubesoloHostResult>
): Record<HostGroup, Array<KubesoloHostResult>> {
  const groups: Record<HostGroup, Array<KubesoloHostResult>> = {
    attention: [],
    running: [],
    queued: [],
    passed: [],
    alreadyInstalled: [],
  };

  hosts.forEach((host) => groups[groupOfState[host.state]].push(host));

  groups.attention.sort(
    (a, b) => Number(!!b.hostKeyChange) - Number(!!a.hostKeyChange)
  );
  groups.queued.sort((a, b) => (a.queuePosition ?? 0) - (b.queuePosition ?? 0));

  return groups;
}
